import { render, staticRenderFns } from "./ZyroButton.vue?vue&type=template&id=6e077d39&scoped=true&"
import script from "./ZyroButton.vue?vue&type=script&lang=js&"
export * from "./ZyroButton.vue?vue&type=script&lang=js&"
import style0 from "./ZyroButton.vue?vue&type=style&index=0&id=6e077d39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e077d39",
  null
  
)

export default component.exports